/**
 * Created by pandemio on 3/4/19.
 */
import React from 'react';
import { Link, Redirect } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons';

/**
 * Modal success for client registration
 */
class ModalSuccess extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: this.props.visible,
            orderNo: this.props.orderNo,
            isEdit: this.props.isEdit,
            subscriptionId: this.props.subscriptionId === null || typeof this.props.subscriptionId === 'undefined' ?
                '' : this.props.subscriptionId,
            redirect: false
        };
        this.toggle = this.toggle.bind(this);
    }

    /**
     * Hide or shows the window
     */
    toggle() {
       this.setState({redirect: true});
    }

    // Render a generic modal. The body text should be sent in the text
    render() {

        if(this.state.redirect && this.state.isEdit)
            return (<Redirect  to={{
                pathname: "/add-child-profile",
                subscriptionId: this.state.subscriptionId
            }}/>);

        if(this.state.redirect && !this.state.isEdit)
            return (<Redirect  to={{
                pathname: "/set-up-child-profile",
                subscriptionId: this.state.subscriptionId
            }}/>);

        return (
            <div>
                <Modal isOpen={this.state.visible} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}/>
                    <ModalBody>
                        <h1><FontAwesomeIcon className="green-text" icon={faCheckCircle}/> {' '}
                            <Translate id="modal-welcome.welcome" options={{renderInnerHtml: true}}/></h1>
                        <br/>
                        <h3><Translate id="modal-welcome.order-confirmation"/></h3>
                        <h2 className="green-text centered-text">{this.state.orderNo}</h2>
                        <br/>
                        <h4><Translate id="modal-welcome.follow-steps"/></h4>
                    </ModalBody>
                    <ModalFooter>
                        {
                            this.state.isEdit ?
                                <div>
                                    <Link to="/dashboard" className="btn btn-warning" onClick={this.toggle}>
                                        <Translate id="modal-welcome.go-to-dashboard"/>
                                    </Link>
                                    {' '}
                                    <Link to={{
                                        pathname: "/add-child-profile",
                                        subscriptionId: this.state.subscriptionId
                                    }} className="btn btn-info" onClick={this.toggle}>
                                        <Translate id="modal-welcome.go-to-add-new-user"/>
                                    </Link>
                                </div> :
                                    <Link to={{
                                    pathname: "/set-up-child-profile",
                                    subscriptionId: this.state.subscriptionId
                                    }} className="btn btn-info" onClick={this.toggle}>
                                        <Translate id="modal-welcome.okay"/>
                                    </Link>
                        }
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default ModalSuccess;